export const TRAILSINFO_LIST_REQUEST = 'TRAILSINFO_LIST_REQUEST'
export const TRAILSINFO_LIST_STATUS_RESET = 'TRAILSINFO_LIST_STATUS_RESET'
export const TRAILSINFO_LIST_SUCCESS = 'TRAILSINFO_LIST_SUCCESS'
export const TRAILSINFO_LIST_ERROR = 'TRAILSINFO_LIST_ERROR'
export const TRAILSINFO_LIST_SET = 'TRAILSINFO_LIST_SET'
export const TRAILSINFO_QUERY_UPDATE = 'TRAILSINFO_QUERY_UPDATE'
export const TRAILSINFO_QUERY_SUCCESS = 'TRAILSINFO_QUERY_SUCCESS'

export const TRAIL_ASSIGN_REQ = 'TRAIL_ASSIGN_REQ'
export const TRAIL_ASSIGN_REQ_SUCCESS = 'TRAIL_ASSIGN_REQ_SUCCESS'
export const TRAIL_ASSIGN_REQ_ERROR = 'TRAIL_ASSIGN_REQ_ERROR'

export const TRAIL_PROCESS_GRAPH_REQ = 'TRAIL_PROCESS_GRAPH_REQ'
export const TRAIL_PROCESS_PATH_ARTIFACTS_REQ = 'TRAIL_PROCESS_PATH_ARTIFACTS_REQ'
export const TRAIL_PROCESS_NETWORK_ARTIFACTS_REQ = 'TRAIL_PROCESS_NETWORK_ARTIFACTS_REQ'

export const TRAIL_DETAILS_REQ = 'TRAIL_DETAILS_REQ'
export const TRAIL_DETAILS_REQ_SUCCESS = 'TRAIL_DETAILS_REQ_SUCCESS'
export const TRAIL_DETAILS_REQ_ERROR = 'TRAIL_DETAILS_REQ_ERROR'

export const TRAIL_WORK_HISTORY_REQ = 'TRAIL_WORK_HISTORY_REQ'
export const TRAIL_WORK_HISTORY_REQ_SUCCESS = 'TRAIL_WORK_HISTORY_REQ_SUCCESS'
export const TRAIL_WORK_HISTORY_REQ_ERROR = 'TRAIL_WORK_HISTORY_REQ_ERROR'

export const TRAIL_SUMMARY_REQ = 'TRAIL_SUMMARY_REQ'
export const TRAIL_SUMMARY_REQ_SUCCESS = 'TRAIL_SUMMARY_REQ_SUCCESS'
export const TRAIL_SUMMARY_REQ_ERROR = 'TRAIL_SUMMARY_REQ_ERROR'
export const TRAIL_SUMMARY_REQ_RESET = 'TRAIL_SUMMARY_REQ_RESET'

export const TRAIL_LATERAL_MOVEMENT_REQ = 'TRAIL_LATERAL_MOVEMENT_REQ'
export const TRAIL_LATERAL_MOVEMENT_REQ_SUCCESS = 'TRAIL_LATERAL_MOVEMENT_REQ_SUCCESS'
export const TRAIL_LATERAL_MOVEMENT_REQ_ERROR = 'TRAIL_LATERAL_MOVEMENT_REQ_ERROR'
export const UNIQ_COMBO_LATERAL_MOVEMENT = 'UNIQ_COMBO_LATERAL_MOVEMENT'
export const UNIQ_COMBO_PRIV_LATERAL_MOVEMENT = 'UNIQ_COMBO_PRIV_LATERAL_MOVEMENT'

export const TRAIL_MITIGATION_REQ = 'TRAIL_MITIGATION_REQ'
export const TRAIL_MITIGATION_REQ_SUCCESS = 'TRAIL_MITIGATION_REQ_SUCCESS'
export const TRAIL_MITIGATION_REQ_ERROR = 'TRAIL_MITIGATION_REQ_ERROR'

export const BULK_TRAIL_MITIGATION_REQ = 'BULK_TRAIL_MITIGATION_REQ'
export const BULK_TRAIL_MITIGATION_REQ_SUCCESS = 'BULK_TRAIL_MITIGATION_REQ_SUCCESS'
export const BULK_TRAIL_MITIGATION_REQ_ERROR = 'BULK_TRAIL_MITIGATION_REQ_ERROR'

export const BULK_TRAIL_REOPEN_MITIGATED_REQ = 'BULK_TRAIL_REOPEN_MITIGATED_REQ'
export const BULK_TRAIL_REOPEN_MITIGATED_REQ_SUCCESS = 'BULK_TRAIL_REOPEN_MITIGATED_REQ_SUCCESS'
export const BULK_TRAIL_REOPEN_MITIGATED_REQ_ERROR = 'BULK_TRAIL_REOPEN_MITIGATED_REQ_ERROR'

export const TRAIL_RESPONSE_IOC_ACTION_REQ = 'TRAIL_RESPONSE_IOC_ACTION_REQ'
export const TRAIL_RESPONSE_IOC_ACTION_REQ_SUCCESS = 'TRAIL_RESPONSE_IOC_ACTION_REQ_SUCCESS'
export const TRAIL_RESPONSE_IOC_ACTION_REQ_ERROR = 'TRAIL_RESPONSE_IOC_ACTION_REQ_ERROR'

export const BULK_TRAIL_RESPONSE_IOC_ACTION_REQ = 'BULK_TRAIL_RESPONSE_IOC_ACTION_REQ'
export const BULK_TRAIL_RESPONSE_IOC_ACTION_REQ_SUCCESS = 'BULK_TRAIL_RESPONSE_IOC_ACTION_REQ_SUCCESS'
export const BULK_TRAIL_RESPONSE_IOC_ACTION_REQ_ERROR = 'BULK_TRAIL_RESPONSE_IOC_ACTION_REQ_ERROR'

export const TRAIL_RESPONSE_ACTION_REQ = 'TRAIL_RESPONSE_ACTION_REQ'
export const TRAIL_RESPONSE_ACTION_SUCCESS = 'TRAIL_RESPONSE_ACTION_SUCCESS'
export const TRAIL_RESPONSE_ACTION_ERROR = 'TRAIL_RESPONSE_ACTION_ERROR'

export const TRAIL_RESPONSE_QUARANTINED_FILES_REQ = 'TRAIL_RESPONSE_QUARANTINED_FILES_REQ'
export const TRAIL_RESPONSE_QUARANTINED_FILES_SUCCESS = 'TRAIL_RESPONSE_QUARANTINED_FILES_SUCCESS'
export const TRAIL_RESPONSE_QUARANTINED_FILES_ERROR = 'TRAIL_RESPONSE_QUARANTINED_FILES_ERROR'

export const TRAIL_RESPONSE_BLOCKED_NETWORKS_REQ = 'TRAIL_RESPONSE_BLOCKED_NETWORKS_REQ'
export const TRAIL_RESPONSE_BLOCKED_NETWORKS_SUCCESS = 'TRAIL_RESPONSE_BLOCKED_NETWORKS_SUCCESS'
export const TRAIL_RESPONSE_BLOCKED_NETWORKS_ERROR = 'TRAIL_RESPONSE_BLOCKED_NETWORKS_ERROR'

export const PRIVILEGED_TRAIL_REQ = 'PRIVILEGED_TRAIL_REQ'
export const PRIVILEGED_TRAIL_SET = 'PRIVILEGED_TRAIL_SET'
export const PRIVILEGED_TRAIL_REQ_SUCCESS = 'PRIVILEGED_TRAIL_REQ_SUCCESS'
export const PRIVILEGED_TRAIL_REQ_ERROR = 'PRIVILEGED_TRAIL_REQ_ERROR'

export const TRAIL_DETAILS_LATERALMOVEMENT_REQ = 'TRAIL_DETAILS_LATERALMOVEMENT_REQ'
export const TRAIL_DETAILS_LATERALMOVEMENT_SET = 'TRAIL_DETAILS_LATERALMOVEMENT_SET'
export const TRAIL_DETAILS_LATERALMOVEMENT_REQ_SUCCESS = 'TRAIL_DETAILS_LATERALMOVEMENT_REQ_SUCCESS'
export const TRAIL_DETAILS_LATERALMOVEMENT_REQ_ERROR = 'TRAIL_DETAILS_LATERALMOVEMENT_REQ_ERROR'

export const MITIGATED_TRAILS_REQUEST = 'MITIGATED_TRAILS_REQUEST'
export const MITIGATED_TRAILS_SUCCESS = 'MITIGATED_TRAILS_SUCCESS'
export const MITIGATED_TRAILS_ERROR = 'MITIGATED_TRAILS_ERROR'
export const MITIGATED_TRAILS_SET = 'MITIGATED_TRAILS_SET'

export const REOPENED_TRAILS_REQUEST = 'REOPENED_TRAILS_REQUEST'
export const REOPENED_TRAILS_SUCCESS = 'REOPENED_TRAILS_SUCCESS'
export const REOPENED_TRAILS_ERROR = 'REOPENED_TRAILS_ERROR'
export const REOPENED_TRAILS_SET = 'REOPENED_TRAILS_SET'
export const REOPENED_TRAILS_STATUS_RESET = 'REOPENED_TRAILS_STATUS_RESET'

export const REOPENED_TRAIL_RANGE_REQ = 'REOPENED_TRAIL_RANGE_REQ'
export const REOPENED_TRAIL_RANGE_REQ_SUCCESS = 'REOPENED_TRAIL_RANGE_REQ_SUCCESS'
export const REOPENED_TRAIL_RANGE_REQ_ERROR = 'REOPENED_TRAIL_RANGE_REQ_ERROR'

export const TRAIL_DETAILS_USER_PREF = 'TRAIL_DETAILS_USER_PREF'

export const SYSTEM_TRAIL_SUMMARY_REQ = 'ACTIVE_TRAIL_SUMMARY_REQ'
export const SYSTEM_TRAIL_SUMMARY_REQ_RESET = 'SYSTEM_TRAIL_SUMMARY_REQ_RESET'

export const ACTIVE_TRAIL_SUMMARY_REQ = 'ACTIVE_TRAIL_SUMMARY_REQ'
export const ACTIVE_TRAIL_SUMMARY_REQ_SUCCESS = 'ACTIVE_TRAIL_SUMMARY_REQ_SUCCESS'
export const ACTIVE_TRAIL_SUMMARY_REQ_ERROR = 'ACTIVE_TRAIL_SUMMARY_REQ_ERROR'

export const PRIVILEGED_TRAIL_SUMMARY_REQ = 'PRIVILEGED_TRAIL_SUMMARY_REQ'
export const PRIVILEGED_TRAIL_SUMMARY_REQ_SUCCESS = 'PRIVILEGED_TRAIL_SUMMARY_REQ_SUCCESS'
export const PRIVILEGED_TRAIL_SUMMARY_REQ_ERROR = 'PRIVILEGED_TRAIL_SUMMARY_REQ_ERROR'

export const MITIGATED_TRAIL_SUMMARY_REQ = 'MITIGATED_TRAIL_SUMMARY_REQ'
export const MITIGATED_TRAIL_SUMMARY_REQ_SUCCESS = 'MITIGATED_TRAIL_SUMMARY_REQ_SUCCESS'
export const MITIGATED_TRAIL_SUMMARY_REQ_ERROR = 'MITIGATED_TRAIL_SUMMARY_REQ_ERROR'

export const ACTIVE_TRAIL_RANGE_REQ = 'ACTIVE_TRAIL_RANGE_REQ'
export const ACTIVE_TRAIL_RANGE_REQ_SUCCESS = 'ACTIVE_TRAIL_RANGE_REQ_SUCCESS'
export const ACTIVE_TRAIL_RANGE_REQ_ERROR = 'ACTIVE_TRAIL_RANGE_REQ_ERROR'

export const PRIVILEGED_TRAIL_RANGE_REQ = 'PRIVILEGED_TRAIL_RANGE_REQ'
export const PRIVILEGED_TRAIL_RANGE_REQ_SUCCESS = 'PRIVILEGED_TRAIL_RANGE_REQ_SUCCESS'
export const PRIVILEGED_TRAIL_RANGE_REQ_ERROR = 'PRIVILEGED_TRAIL_RANGE_REQ_ERROR'

export const MITIGATED_TRAIL_RANGE_REQ = 'MITIGATED_TRAIL_RANGE_REQ'
export const MITIGATED_TRAIL_RANGE_REQ_SUCCESS = 'MITIGATED_TRAIL_RANGE_REQ_SUCCESS'
export const MITIGATED_TRAIL_RANGE_REQ_ERROR = 'MITIGATED_TRAIL_RANGE_REQ_ERROR'

export const TRAIL_RECOMMENDATION_PROGRESS_REQ = 'TRAIL_RECOMMENDATION_PROGRESS_REQ'

export const TRAILSINFO_FINGERPRINT_REQUEST = 'TRAILSINFO_FINGERPRINT_REQUEST'
export const TRAILSINFO_FINGERPRINT_STATUS_RESET = 'TRAILSINFO_FINGERPRINT_STATUS_RESET'
export const TRAILSINFO_FINGERPRINT_SUCCESS = 'TRAILSINFO_FINGERPRINT_SUCCESS'
export const TRAILSINFO_FINGERPRINT_ERROR = 'TRAILSINFO_FINGERPRINT_ERROR'
export const TRAILSINFO_FINGERPRINT_SET = 'TRAILSINFO_FINGERPRINT_SET'

export const MITIGATE_FINGERPRINT_REQUEST = 'MITIGATE_FINGERPRINT_REQUEST'
export const MITIGATE_FINGERPRINT_STATUS_RESET = 'MITIGATE_FINGERPRINT_STATUS_RESET'
export const MITIGATE_FINGERPRINT_SUCCESS = 'MITIGATE_FINGERPRINT_SUCCESS'
export const MITIGATE_FINGERPRINT_ERROR = 'MITIGATE_FINGERPRINT_ERROR'
export const MITIGATE_FINGERPRINT_SET = 'MITIGATE_FINGERPRINT_SET'

export const ACCOUNT_KEY_PROGRESSIONS_SET = 'ACCOUNT_KEY_PROGRESSIONS_SET'
export const ACCOUNT_KEY_PROGRESSIONS_REQ = 'ACCOUNT_KEY_PROGRESSIONS_REQ'
export const ACCOUNT_KEY_PROGRESSIONS_SUCCESS = 'ACCOUNT_KEY_PROGRESSIONS_SUCCESS'
export const ACCOUNT_KEY_PROGRESSIONS_ERROR = 'ACCOUNT_KEY_PROGRESSIONS_ERROR'
export const ACCOUNT_KEY_PROGRESSIONS_RESET_STATUS = 'ACCOUNT_KEY_PROGRESSIONS_RESET_STATUS'

export const MULTIPLE_ACCOUNT_KEY_PROGRESSIONS_SET = 'MULTIPLE_ACCOUNT_KEY_PROGRESSIONS_SET'
export const MULTIPLE_ACCOUNT_KEY_PROGRESSIONS_REQ = 'MULTIPLE_ACCOUNT_KEY_PROGRESSIONS_REQ'
export const MULTIPLE_ACCOUNT_KEY_PROGRESSIONS_SUCCESS = 'MULTIPLE_ACCOUNT_KEY_PROGRESSIONS_SUCCESS'
export const MULTIPLE_ACCOUNT_KEY_PROGRESSIONS_ERROR = 'MULTIPLE_ACCOUNT_KEY_PROGRESSIONS_ERROR'
export const MULTIPLE_ACCOUNT_KEY_PROGRESSIONS_RESET_STATUS = 'MULTIPLE_ACCOUNT_KEY_PROGRESSIONS_RESET_STATUS'

export const VM_VIEW_PREFERENCES_REQ = 'VM_VIEW_PREFERENCES_REQ'
export const SAVE_VM_VIEW_PREFERENCES = 'SAVE_VM_VIEW_PREFERENCES'

export const ACTIVE_PROGRESSION_VIEW_PREFERENCES_REQ = 'ACTIVE_PROGRESSION_VIEW_PREFERENCES_REQ'
export const SAVE_ACTIVE_PROGRESSION_VIEW_PREFERENCES = 'SAVE_ACTIVE_PROGRESSION_VIEW_PREFERENCES'

export const REOPENED_PROGRESSION_VIEW_PREFERENCES_REQ = 'REOPENED_PROGRESSION_VIEW_PREFERENCES_REQ'
export const SAVE_REOPENED_PROGRESSION_VIEW_PREFERENCES = 'SAVE_REOPENED_PROGRESSION_VIEW_PREFERENCES'

export const MITIGATED_PROGRESSION_VIEW_PREFERENCES_REQ = 'MITIGATED_PROGRESSION_VIEW_PREFERENCES_REQ'
export const SAVE_MITIGATED_PROGRESSION_VIEW_PREFERENCES = 'SAVE_MITIGATED_PROGRESSION_VIEW_PREFERENCES'

export const PRIVILEGED_ACTIVITIES_TRAILS_PREFERENCES_VIEW_REQ = 'PRIVILEGED_ACTIVITIES_TRAILS_PREFERENCES_VIEW_REQ'
export const SAVE_PRIVILEGED_ACTIVITIES_TRAILS_VIEW_PREFERENCES = 'SAVE_PRIVILEGED_ACTIVITIES_TRAILS_VIEW_PREFERENCES'

export const PRIV_VIEW_ACTIVITIES_PREFERENCES_REQ = 'PRIV_VIEW_ACTIVITIES_PREFERENCES_REQ'
export const SAVE_PRIV_VIEW_ACTIVITIES_PREFERENCES = 'SAVE_PRIV_VIEW_ACTIVITIES_PREFERENCES'


export const NETWORK_VIEW_PREFERENCES_REQ = 'NETWORK_VIEW_PREFERENCES_REQ'
export const SAVE_NETWORK_VIEW_PREFERENCES = 'SAVE_NETWORK_VIEW_PREFERENCES'

export const QUARANTINED_FILES_VIEW_PREFERENCES_REQ = 'QUARANTINED_FILES_VIEW_PREFERENCES_REQ'
export const SAVE_QUARANTINED_FILES_VIEW_PREFERENCES = 'SAVE_QUARANTINED_FILES_VIEW_PREFERENCES'



// WEBPACK FOOTER //
// ./src/store/modules/trails/trailsinfo.type.js